export class DigitalCaseflowActivityTableEntry {
  name: string;
  message: string;
  status: string;

  public constructor(name: string, message: string, status: string) {
    this.name = name;
    this.message = message;
    this.status = status;
  }
}
